<div id="popup" style="height: 100%; max-height: 100%; overflow: hidden; display: flex; flex-direction: column;"
    *ngIf="taskType == 1" class="oldtaskTypeOne">
    <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center" style="flex-shrink: 0;">
        <span>
            Activity
        </span>
        <button [attr.guide]="'conversation-popup-btn-1' + '__' + sanitizeUrl(url)" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <mat-dialog-content
        style="margin: 0; padding: 0; overflow-y: auto; overflow-x: hidden; flex: 1; height: 0; min-height: 0;">
        <div class="padding-11">
            <div fxLayout="column" [formGroup]="firstFormGroup">

                <div class="Activity Details">

                    <div *ngIf="(firstFormGroup.controls.activityType.value !='Phone Call') && firstFormGroup.controls.phoneCallOutcome.value=='Followup' || firstFormGroup.controls.phoneCallOutcome.value=='Demo' || firstFormGroup.controls.phoneCallOutcome.value=='Payment Followup'"
                        fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" class="checkbox-new">
                        <mat-checkbox [attr.guide]="'conversation-popup-chk-status' + '__' + sanitizeUrl(url)"
                            formControlName="status">
                            Mark as Completed
                        </mat-checkbox>
                    </div>

                    <div>
                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Activity Type</mat-label>
                                <mat-select formControlName="activityType" [disabled]="activityType=='Edit'">
                                    <mat-option *ngFor="let status of activityTypeList" [value]="status.value">
                                        {{status.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field *ngIf="type!='lead'" appearance="outline" fxFlex>
                                <mat-label>Associated Lead</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-2' + '__' + sanitizeUrl(url)"
                                    [readonly]="activityId > 0" [autocomplete]="'off'" trim="blur" matInput
                                    formControlName="owner">
                            </mat-form-field>

                        </div>



                        <div *ngIf="firstFormGroup.controls.activityType.value =='Phone Call'" fxLayout="row"
                            fxLayout.lt-md="column" fxLayoutGap="10px">
                            <mat-form-field fxFlex appearance="outline" [bdcWalkTriggerFor]="example2Step2"
                                #step2Trigger>
                                <mat-label>Call OutCome</mat-label>
                                <mat-select [attr.guide]="'crm-setting-select-leadstatus' + '__' + sanitizeUrl(url)"
                                    formControlName="callOutcome" (selectionChange)="onCallOutcomeChange($event)"
                                    [disableOptionCentering]="true" #singleSelect autocomplete="off">
                                    <mat-option>
                                        <ngx-mat-select-search name="Call OutCome Search" ngDefaultControl
                                            [formControl]="typeCallOutcomeFilterControl"
                                            placeholderLabel="Call OutCome Search" [preventHomeEndKeyPropagation]="true"
                                            noEntriesFoundLabel="No data found">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let opt of filteredCallOutcomeTypeList; let i=index;"
                                        [value]="opt?.statusName || opt?.value || opt">
                                        {{ opt?.statusName || opt?.viewValue || opt?.name || opt?.value || opt }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="firstFormGroup.controls.callOutcome.errors?.required">
                                    Please fill out this field.

                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div *ngIf="durarationVisible" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">


                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Duration</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-typeandtime' + '__' + sanitizeUrl(url)"
                                    numbersOnly [readonly]=" firstFormGroup.value.automated==1" [autocomplete]="'off'"
                                    trim="blur" matInput formControlName="typeAndTime" />
                            </mat-form-field>

                        </div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <div fxFlex="100" *ngIf="!durarationVisible&&firstFormGroup.controls
                            .activityType.value =='Phone Call';else other_content">

                                <mat-form-field appearance="outline" fxFlex=100>
                                    <mat-label>Notes</mat-label>
                                    <textarea [attr.guide]="'conversation-popup-sel-notes' + '__' + sanitizeUrl(url)"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="notes" matInput>
                                                </textarea>
                                    <mat-error *ngIf="firstFormGroup.controls.notes.errors?.required">
                                        Please fill out this field.
                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <ng-template #other_content>
                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Notes</mat-label>
                                    <textarea [attr.guide]="'conversation-popup-sel-notes' + '__' + sanitizeUrl(url)"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        required matInput formControlName="notes" matInput>
                                                </textarea>
                                    <mat-error *ngIf="firstFormGroup.controls.notes.errors?.required">
                                        Please fill out this field.
                                    </mat-error>

                                </mat-form-field></ng-template>

                        </div>




                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <mat-form-field fxFlex appearance="outline"
                                *ngIf="firstFormGroup.value.activityType!='Location'">
                                <mat-label *ngIf="firstFormGroup.value.activityType =='Phone Call'">
                                    Next Outcome</mat-label>

                                <mat-label *ngIf="firstFormGroup.value.activityType !='Phone Call'">
                                    Outcome</mat-label>
                                <mat-select formControlName="phoneCallOutcome" [disableOptionCentering]="true"
                                    #singleSelect autocomplete="off"
                                    [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0">
                                    <mat-option [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0">
                                        <ngx-mat-select-search name="Lead Status Search" ngDefaultControl
                                            [formControl]="typeYFilterControl" placeholderLabel="Lead Status Search"
                                            [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0"
                                        (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId)"
                                        *ngFor="let opt of filtereddropdownTypeList; let i=index;"
                                        [value]="opt.statusName">
                                        {{opt.statusName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>


                        </div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <div *ngIf="init&&regConfig.length>0" fxFlex="100">

                                <simple-dynamic-form (submit)="onFormSubmitted($event)"
                                    [patchValueList]="simpleFormValueList" [type]="2" fxFlex="100" [fields]="regConfig">
                                </simple-dynamic-form>


                            </div>

                        </div>

                        <div
                            *ngIf="firstFormGroup.controls.phoneCallOutcome.value=='Followup' || firstFormGroup.controls.phoneCallOutcome.value=='Demo' || firstFormGroup.controls.phoneCallOutcome.value=='Payment Followup'">
                            <div *ngIf="!displayNewline" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                                    <mat-label>Follow up Date</mat-label>
                                    <input
                                        [attr.guide]="'conversation-popup-inp-followupdate' + '__' + sanitizeUrl(url)"
                                        [disabled]="activityType=='Edit'" [min]="firstFormGroup.value.id==0?today:'  '"
                                        [matDatepicker]="followUp" formControlName="followupDate"
                                        [required]="firstFormGroup.value.id==0" matInput />
                                    <mat-datepicker-toggle [for]="followUp" matSuffix></mat-datepicker-toggle>
                                    <mat-datepicker #followUp></mat-datepicker>

                                    <mat-error *ngIf="firstFormGroup.controls.followupDate.errors?.required">
                                        Please fill out this field.
                                    </mat-error>
                                </mat-form-field>


                                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                                    <mat-label>Follow up Time</mat-label>
                                    <input
                                        [attr.guide]="'conversation-popup-inp-followuptime' + '__' + sanitizeUrl(url)"
                                        [disabled]="activityType=='Edit'" type="time" formControlName="followupTime"
                                        required matInput />

                                    <mat-error *ngIf="firstFormGroup.controls.followupTime.errors?.required">
                                        Please fill out this field.
                                    </mat-error>

                                </mat-form-field>

                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Zone</mat-label>
                                    <mat-select formControlName="timeZone" [disabled]="activityType=='Edit'">
                                        <mat-option *ngFor="let status of zone" [value]="status.value">
                                            {{status.label}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                            </div>

                            <div *ngIf="displayNewline" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                                    <mat-label>Follow up Date</mat-label>
                                    <input
                                        [attr.guide]="'conversation-popup-inp-followupdate' + '__' + sanitizeUrl(url)"
                                        [disabled]="activityType=='Edit'" [min]="firstFormGroup.value.id==0?today:'  '"
                                        [matDatepicker]="followUp" formControlName="followupDate"
                                        [required]="firstFormGroup.value.id==0" matInput />
                                    <mat-datepicker-toggle [for]="followUp" matSuffix></mat-datepicker-toggle>
                                    <mat-datepicker #followUp></mat-datepicker>

                                    <mat-error *ngIf="firstFormGroup.controls.followupDate.errors?.required">
                                        Please fill out this field.
                                    </mat-error>
                                </mat-form-field>

                            </div>

                            <div *ngIf="displayNewline" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">


                                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                                    <mat-label>Follow up Time</mat-label>
                                    <input
                                        [attr.guide]="'conversation-popup-inp-followuptime' + '__' + sanitizeUrl(url)"
                                        [disabled]="activityType=='Edit'" type="time" formControlName="followupTime"
                                        required matInput />

                                    <mat-error *ngIf="firstFormGroup.controls.followupTime.errors?.required">
                                        Please fill out this field.
                                    </mat-error>

                                </mat-form-field>
                            </div>

                            <div *ngIf="displayNewline" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Zone</mat-label>
                                    <mat-select formControlName="timeZone" [disabled]="activityType=='Edit'">
                                        <mat-option *ngFor="let status of zone" [value]="status.value">
                                            {{status.label}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                            </div>
                        </div>

                        <div
                            *ngIf="firstFormGroup.controls.phoneCallOutcome.value=='Followup' || firstFormGroup.controls.phoneCallOutcome.value=='Demo' || firstFormGroup.controls.phoneCallOutcome.value=='Payment Followup'">
                            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                                <mat-form-field fxFlex appearance="outline">
                                    <mat-label>Select Message Template</mat-label>
                                    <mat-select formControlName="templateId" [disableOptionCentering]="true"
                                        #singleSelect name="item">
                                        <mat-option>
                                            <ngx-mat-select-search name="WhatsApp Template Message Search"
                                                ngDefaultControl [formControl]="
                                WhatsappTemplateMessageFilterControl
                            " placeholderLabel="WhatsApp Template Message Search" [preventHomeEndKeyPropagation]="
                              true
                            " noEntriesFoundLabel="No data found">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let opt of filteredWhatsappTemplateMessageTypeList;"
                                            [value]="opt.messageTemplateId">
                                            {{ opt.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <div *ngIf="enableLocation == '1' && firstFormGroup.value.activityType !='Location' && firstFormGroup.controls.phoneCallOutcome.value!='Followup'"
                            fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <div *ngIf="textmap !== 'Get Current Location'">{{ textmap }}</div>
                            <mat-form-field *ngIf="textmap === 'Get Current Location'" appearance="outline" fxFlex>
                                <mat-label>Location</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-customeraddress' + '__' + sanitizeUrl(url)"
                                    readonly formControlName="customerAddress" matInput />
                            </mat-form-field>
                        </div>






                        <div fxLayout="column" fxLayout.lt-md="column" fxLayoutGap="10px" fxLayoutAlign="start stretch"
                            *ngIf="firstFormGroup.value.activityType=='Location'">
                            <mat-form-field appearance="outline" fxFlex="70" fxFlex.lt-md="100">
                                <mat-label>Add Location</mat-label>
                                <textarea
                                    [attr.guide]="'conversation-popup-sel-customeraddress' + '__' + sanitizeUrl(url)"
                                    readonly trim="blur" matTextareaAutosize matAutosizeMinRows="1"
                                    matAutosizeMaxRows="5" matInput formControlName="customerAddress">
                            </textarea>
                            </mat-form-field>

                            <div fxFlex="30" fxFlex.lt-md="100" fxLayoutAlign="start center"
                                class="location-button-container">

                                <button [attr.guide]="'conversation-popup-btn-3' + '__' + sanitizeUrl(url)"
                                    [disabled]="textmap !='Get Current Location'" (click)="getUserLocation()"
                                    mat-raised-button>
                                    <mat-icon>gps_fixed</mat-icon>
                                    {{textmap}}
                                    <mat-icon *ngIf="textmap !='Get Current Location' ">
                                        <mat-spinner color="primary" diameter="20">
                                        </mat-spinner>
                                    </mat-icon>
                                </button>

                            </div>
                        </div>

                    </div>
                </div>

                <div class="Add Task">

                    <div *ngIf="
  firstFormGroup.controls.phoneCallOutcome.value?.toLowerCase() !== 'completed' &&
  firstFormGroup.controls.phoneCallOutcome.value?.toLowerCase() !== 'pending'
">


                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <!-- <div *ngIf="firstFormGroup.controls.nextAction.value=='Followup'">

                                <mat-form-field fxFlex="100" appearance="outline" fxLayoutGap="10px">
                                    <mat-label>Schedule</mat-label>
                                    <input [attr.guide]="'conversation-popup-inp-schedule' + '__' + sanitizeUrl(url)" [disabled]="activityType=='Edit'" [matDatepicker]="startDatepicker"
                                        formControlName="schedule" matInput/>
                                    <mat-datepicker-toggle [for]="startDatepicker" matSuffix></mat-datepicker-toggle>
                                    <mat-datepicker #startDatepicker
                                        startAt="{{ today | date: 'yyyy-MM-dd' }}"></mat-datepicker>
                                </mat-form-field>

                            </div> -->


                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Reminder Before the task</mat-label>
                                <mat-select formControlName="reminder" [disabled]="activityType=='Edit'">
                                    <mat-option *ngFor="let status of reminder" [value]="status.value">
                                        {{status.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="firstFormGroup.controls.reminder.errors?.required">
                                    Please fill out this field.
                                </mat-error>
                            </mat-form-field>



                        </div>


                    </div>

                </div>

                <div fxLayout="row" *ngIf="firstFormGroup.value.activityType =='Phone Call'
                && firstFormGroup.value.automated== 0">

                    <div class="audio" fxLayoutAlign="center center">

                        <span fxLayoutAlign="center center">
                            Audio File
                        </span>

                    </div>

                    <calsoft-audio-upload fxFlex="100" [finalValue]="firstFormGroup.value.schedule"
                        (sendValue)="getValue($event)">

                    </calsoft-audio-upload>
                </div>

            </div>

            <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">

                <button [attr.guide]="'conversation-popup-btn-4' + '__' + sanitizeUrl(url)" type="button"
                    mat-raised-button (click)="close()">Cancel
                </button>

                <button [attr.guide]="'conversation-popup-btn-5' + '__' + sanitizeUrl(url)" [disabled]="text !='Save'"
                    (click)="submit()" mat-raised-button>
                    {{text}}
                    <mat-icon *ngIf="text !='Save' ">
                        <mat-spinner color="primary" diameter="20">
                        </mat-spinner>
                    </mat-icon>
                </button>


            </div>
        </div>
    </mat-dialog-content>
</div>
<div id="popup" *ngIf="taskType == 2" class="newTypetaskTwo">
    <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <span>
            Activity
        </span>
        <button [attr.guide]="'conversation-popup-btn-6' + '__' + sanitizeUrl(url)" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <mat-dialog-content style="max-height: calc(100vh - 64px); margin: 0; padding: 0; overflow: auto;">
        <div class="padding-11">
            <div fxLayout="column" [formGroup]="firstFormGroup">

                <div class="Activity Details">

                    <div>
                        <div fxLayout="column">
                            <div *ngIf="(firstFormGroup.controls.activityType.value !='Phone Call') && firstFormGroup.controls.phoneCallOutcome.value=='Followup' || firstFormGroup.controls.phoneCallOutcome.value=='Demo' || firstFormGroup.controls.phoneCallOutcome.value=='Payment Followup'"
                                fxLayout="row" class="checkbox-new">
                                <mat-checkbox [attr.guide]="'conversation-popup-chk-status' + '__' + sanitizeUrl(url)"
                                    formControlName="status">
                                    Mark as Completed
                                </mat-checkbox>
                            </div>
                            <mat-form-field *ngIf="firstFormGroup.controls.activityType.value !='Phone Call'"
                                appearance="outline" fxFlex>
                                <mat-label>Title</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-subject' + '__' + sanitizeUrl(url)"
                                    formControlName="subject" matInput />
                                <!-- <mat-error *ngIf="firstFormGroup.controls.subject.errors?.required">
                                    Please fill out this field.
                                </mat-error> -->
                            </mat-form-field>

                        </div>





                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Task Type</mat-label>
                                <mat-select formControlName="activityType" [disabled]="activityType=='Edit'">
                                    <mat-option *ngFor="let status of activityTypeList" [value]="status.value">
                                        {{status.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>



                            <mat-form-field *ngIf="type!='lead'" appearance="outline" fxFlex>
                                <mat-label>Associated Lead</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-7' + '__' + sanitizeUrl(url)"
                                    [readonly]="activityId > 0" [autocomplete]="'off'" trim="blur" matInput
                                    formControlName="owner">
                            </mat-form-field>

                        </div>

                        <div *ngIf="firstFormGroup.controls.activityType.value =='Phone Call'" fxLayout="row"
                            fxLayout.lt-md="column" fxLayoutGap="10px">

                            <mat-form-field fxFlex appearance="outline" [bdcWalkTriggerFor]="example2Step2"
                                #step2Trigger>
                                <mat-label>Call OutCome</mat-label>
                                <mat-select [attr.guide]="'crm-setting-select-leadstatus' + '__' + sanitizeUrl(url)"
                                    formControlName="callOutcome" (selectionChange)="onCallOutcomeChange($event)"
                                    [disableOptionCentering]="true" #singleSelect autocomplete="off">
                                    <mat-option>
                                        <ngx-mat-select-search name="Call OutCome Search" ngDefaultControl
                                            [formControl]="typeCallOutcomeFilterControl"
                                            placeholderLabel="Call OutCome Search" [preventHomeEndKeyPropagation]="true"
                                            noEntriesFoundLabel="No data found">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let opt of filteredCallOutcomeTypeList; let i=index;"
                                        [value]="opt?.statusName || opt?.value || opt">
                                        {{ opt?.statusName || opt?.viewValue || opt?.name || opt?.value || opt }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="firstFormGroup.controls.callOutcome.errors?.required">
                                    Please fill out this field.

                                </mat-error>
                            </mat-form-field>

                        </div>

                        <div *ngIf="durarationVisible" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">


                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Duration</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-typeandtime' + '__' + sanitizeUrl(url)"
                                    numbersOnly [readonly]=" firstFormGroup.value.automated==1" [autocomplete]="'off'"
                                    trim="blur" matInput formControlName="typeAndTime" />
                            </mat-form-field>

                        </div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <div fxFlex="100" *ngIf="!durarationVisible&&firstFormGroup.controls
                            .activityType.value =='Phone Call';else other_content">

                                <mat-form-field appearance="outline" fxFlex=100>
                                    <mat-label>Notes</mat-label>
                                    <textarea [attr.guide]="'conversation-popup-sel-notes' + '__' + sanitizeUrl(url)"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="notes" matInput>
                                                </textarea>
                                    <mat-error *ngIf="firstFormGroup.controls.notes.errors?.required">
                                        Please fill out this field.
                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <ng-template #other_content>
                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Notes</mat-label>
                                    <textarea [attr.guide]="'conversation-popup-sel-notes' + '__' + sanitizeUrl(url)"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        required matInput formControlName="notes" matInput>
                                                </textarea>
                                    <mat-error *ngIf="firstFormGroup.controls.notes.errors?.required">
                                        Please fill out this field.
                                    </mat-error>

                                </mat-form-field></ng-template>

                        </div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <mat-form-field fxFlex appearance="outline"
                                *ngIf="firstFormGroup.controls.activityType.value!='Location'">
                                <mat-label *ngIf="firstFormGroup.value.activityType =='Phone Call'">
                                    Next Outcome</mat-label>

                                <mat-label *ngIf="firstFormGroup.value.activityType !='Phone Call'">
                                    Outcome</mat-label>
                                <mat-select formControlName="phoneCallOutcome" [disableOptionCentering]="true"
                                    #singleSelect autocomplete="off"
                                    [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0">
                                    <mat-option [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0">
                                        <ngx-mat-select-search name="Lead Status Search" ngDefaultControl
                                            [formControl]="typeYFilterControl" placeholderLabel="Lead Status Search"
                                            [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0"
                                        (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId)"
                                        *ngFor="let opt of filtereddropdownTypeList; let i=index;"
                                        [value]="opt.statusName">
                                        {{opt.statusName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>


                        </div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <div *ngIf="init&&regConfig.length>0" fxFlex="100">

                                <simple-dynamic-form (submit)="onFormSubmitted($event)"
                                    [patchValueList]="simpleFormValueList" [type]="2" fxFlex="100" [fields]="regConfig">
                                </simple-dynamic-form>


                            </div>

                        </div>

                        <div *ngIf="firstFormGroup.controls.phoneCallOutcome.value !='Completed' && firstFormGroup.controls.phoneCallOutcome.value !='completed'"
                            fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <!-- Date picker -->
                            <mat-form-field appearance="outline" fxFlex="50">
                                <mat-label>Due Date</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-duedate' + '__' + sanitizeUrl(url)"
                                    matInput [min]="firstFormGroup.value.id==0?today:'  '" [matDatepicker]="picker"
                                    formControlName="dueDate" placeholder="MM/DD/YYYY" />
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="50">
                                <mat-label>Due Time</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-duetime' + '__' + sanitizeUrl(url)"
                                    matInput
                                    [readonly]="firstFormGroup.value.status == '1' && firstFormGroup.value.id > 0"
                                    type="time" class="custom-time-input" formControlName="dueTime" />
                            </mat-form-field>
                        </div>


                        <div *ngIf="enableLocation == '1' && firstFormGroup.controls.activityType.value !='Location' && firstFormGroup.controls.phoneCallOutcome.value!='Followup'"
                            fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <div *ngIf="textmap !== 'Get Current Location'">{{ textmap }}</div>
                            <mat-form-field *ngIf="textmap === 'Get Current Location'" appearance="outline" fxFlex>
                                <mat-label>Location</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-customeraddress' + '__' + sanitizeUrl(url)"
                                    readonly formControlName="customerAddress" matInput />
                            </mat-form-field>
                        </div>
                        <p style="color:red;margin-top: -20px;margin-bottom: 10px;" *ngIf="initNotes">Please fill out
                            this field.</p>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxLayoutAlign="start stretch"
                            *ngIf="firstFormGroup.controls.activityType.value=='Location'">
                            <mat-form-field appearance="outline" fxFlex="70" fxFlex.lt-md="100">
                                <mat-label>Add Location</mat-label>
                                <textarea
                                    [attr.guide]="'conversation-popup-sel-customeraddress' + '__' + sanitizeUrl(url)"
                                    readonly trim="blur" matTextareaAutosize matAutosizeMinRows="1"
                                    matAutosizeMaxRows="5" matInput formControlName="customerAddress">
                            </textarea>
                            </mat-form-field>

                            <div fxFlex="30" fxFlex.lt-md="100" fxLayoutAlign="start center"
                                class="location-button-container">

                                <button [attr.guide]="'conversation-popup-btn-8' + '__' + sanitizeUrl(url)"
                                    [disabled]="textmap !='Get Current Location'" (click)="getUserLocation()"
                                    mat-raised-button>
                                    <mat-icon>gps_fixed</mat-icon>
                                    {{textmap}}
                                    <mat-icon *ngIf="textmap !='Get Current Location' ">
                                        <mat-spinner color="primary" diameter="20">
                                        </mat-spinner>
                                    </mat-icon>
                                </button>

                            </div>
                        </div>


                        <div *ngIf="
  firstFormGroup.controls.phoneCallOutcome.value?.toLowerCase() !== 'completed' &&
  firstFormGroup.controls.phoneCallOutcome.value?.toLowerCase() !== 'pending'
">

                            <div style="padding-top: 10px;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">



                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Reminder Before the task</mat-label>
                                    <mat-select formControlName="reminder" [disabled]="activityType=='Edit'">
                                        <mat-option *ngFor="let status of reminder" [value]="status.value">
                                            {{status.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="firstFormGroup.controls.reminder.errors?.required">
                                        Please fill out this field.
                                    </mat-error>
                                </mat-form-field>



                            </div>


                        </div>

                        <div fxLayout="row" *ngIf="firstFormGroup.value.activityType =='Phone Call'
                && firstFormGroup.value.automated== 0">

                            <div class="audio" fxLayoutAlign="center center">

                                <span fxLayoutAlign="center center">
                                    Audio File
                                </span>

                            </div>

                            <calsoft-audio-upload fxFlex="100" [finalValue]="firstFormGroup.value.schedule"
                                (sendValue)="getValue($event)">

                            </calsoft-audio-upload>
                        </div>

                    </div>
                </div>



            </div>

            <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">

                <button [attr.guide]="'conversation-popup-btn-9' + '__' + sanitizeUrl(url)" type="button"
                    mat-raised-button (click)="close()">Cancel
                </button>

                <button [attr.guide]="'conversation-popup-btn-10' + '__' + sanitizeUrl(url)" [disabled]="text !='Save'"
                    (click)="submit()" mat-raised-button>
                    {{text}}
                    <mat-icon *ngIf="text !='Save' ">
                        <mat-spinner color="primary" diameter="20">
                        </mat-spinner>
                    </mat-icon>
                </button>


            </div>
        </div>
    </mat-dialog-content>
</div>



<div id="popup" *ngIf="taskType == 3" class="newTypetaskTwo">
    <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <span>
            You marked the task complete.
        </span>
        <button [attr.guide]="'conversation-popup-btn-11' + '__' + sanitizeUrl(url)" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <mat-dialog-content style="max-height: calc(100vh - 64px); margin: 0; padding: 0; overflow: auto;">
        <div class="padding-11">
            <div fxLayout="column" [formGroup]="firstFormGroup">

                <div class="Activity Details">

                    <div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <mat-form-field fxFlex appearance="outline"
                                *ngIf="firstFormGroup.controls.activityType.value!='Location'">
                                <mat-label *ngIf="firstFormGroup.value.activityType =='Phone Call'">
                                    Next Outcome</mat-label>

                                <mat-label *ngIf="firstFormGroup.value.activityType !='Phone Call'">
                                    Outcome</mat-label>
                                <mat-select formControlName="phoneCallOutcome"
                                    [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0"
                                    [disableOptionCentering]="true" #singleSelect autocomplete="off">
                                    <mat-option [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0">
                                        <ngx-mat-select-search name="Lead Status Search" ngDefaultControl
                                            [formControl]="typeYFilterControl" placeholderLabel="Lead Status Search"
                                            [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0"
                                        (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId)"
                                        *ngFor="let opt of filtereddropdownTypeList; let i=index;"
                                        [value]="opt.statusName">
                                        {{opt.statusName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>


                        </div>

                        <div *ngIf="init&&regConfig.length>0" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <div fxFlex="100">

                                <simple-dynamic-form (submit)="onFormSubmitted($event)"
                                    [patchValueList]="simpleFormValueList" [type]="2" fxFlex="100" [fields]="regConfig">
                                </simple-dynamic-form>


                            </div>

                        </div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <div fxFlex="100" *ngIf="!durarationVisible&&firstFormGroup.controls
                            .activityType.value =='Phone Call';else other_content">

                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Notes</mat-label>
                                    <textarea [attr.guide]="'conversation-popup-sel-notes' + '__' + sanitizeUrl(url)"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="notes" matInput>
                                                </textarea>
                                    <mat-error *ngIf="firstFormGroup.controls.notes.errors?.required">
                                        Please fill out this field.
                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <ng-template #other_content>
                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Notes</mat-label>
                                    <textarea [attr.guide]="'conversation-popup-sel-notes' + '__' + sanitizeUrl(url)"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        required matInput formControlName="notes" matInput>
                                                </textarea>
                                    <mat-error *ngIf="firstFormGroup.controls.notes.errors?.required">
                                        Please fill out this field.
                                    </mat-error>

                                </mat-form-field></ng-template>

                        </div>



                        <div fxLayout="row" *ngIf="firstFormGroup.value.activityType =='Phone Call'
                && firstFormGroup.value.automated== 0">

                            <div class="audio" fxLayoutAlign="center center">

                                <span fxLayoutAlign="center center">
                                    Audio File
                                </span>

                            </div>

                            <calsoft-audio-upload fxFlex="100" [finalValue]="firstFormGroup.value.schedule"
                                (sendValue)="getValue($event)">

                            </calsoft-audio-upload>
                        </div>



                    </div>
                </div>




            </div>

            <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">

                <button [attr.guide]="'conversation-popup-btn-12' + '__' + sanitizeUrl(url)" type="button"
                    mat-raised-button (click)="close()">Cancel
                </button>

                <button [attr.guide]="'conversation-popup-btn-13' + '__' + sanitizeUrl(url)" [disabled]="text !='Save'"
                    (click)="submit()" mat-raised-button>
                    {{text}}
                    <mat-icon *ngIf="text !='Save' ">
                        <mat-spinner color="primary" diameter="20">
                        </mat-spinner>
                    </mat-icon>
                </button>


            </div>
        </div>
    </mat-dialog-content>
</div>

<div id="popup" *ngIf="taskType == 5" class="newTypetaskTwo">
    <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <span>
            Activity
        </span>
        <button [attr.guide]="'conversation-popup-btn-14' + '__' + sanitizeUrl(url)" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <mat-dialog-content style="max-height: calc(100vh - 64px); margin: 0; padding: 0; overflow: auto;">
        <div class="padding-11">
            <div fxLayout="column" [formGroup]="firstFormGroup">

                <div class="Activity Details">

                    <div>
                        <div fxLayout="column">
                            <!-- <div *ngIf="(firstFormGroup.controls.activityType.value !='Phone Call') && firstFormGroup.controls.phoneCallOutcome.value?.toLowerCase() !== 'completed' &&
  firstFormGroup.controls.phoneCallOutcome.value?.toLowerCase() !== 'pending'
" fxLayout="row" class="checkbox-new">
                                <mat-checkbox [attr.guide]="'conversation-popup-chk-status' + '__' + sanitizeUrl(url)"
                                    formControlName="status">
                                    Mark as Completed
                                </mat-checkbox>
                            </div> -->
                            <!-- <mat-form-field *ngIf="firstFormGroup.controls.activityType.value !='Phone Call'"
                                appearance="outline" fxFlex>
                                <mat-label>Title</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-subject' + '__' + sanitizeUrl(url)"
                                    formControlName="subject" matInput />
                            </mat-form-field> -->

                        </div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Task Type</mat-label>
                                <mat-select formControlName="activityType" [disabled]="activityType=='Edit'">
                                    <mat-option *ngFor="let status of activityTypeList" [value]="status.value">
                                        {{status.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>



                            <mat-form-field *ngIf="type!='lead'" appearance="outline" fxFlex>
                                <mat-label>Associated Lead</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-15' + '__' + sanitizeUrl(url)"
                                    [readonly]="activityId > 0" [autocomplete]="'off'" trim="blur" matInput
                                    formControlName="owner">
                            </mat-form-field>

                        </div>



                        <div *ngIf="durarationVisible" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">


                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Duration</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-typeandtime' + '__' + sanitizeUrl(url)"
                                    numbersOnly [readonly]=" firstFormGroup.value.automated==1" [autocomplete]="'off'"
                                    trim="blur" matInput formControlName="typeAndTime" />
                            </mat-form-field>

                        </div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <div fxFlex="100" *ngIf="!durarationVisible&&firstFormGroup.controls
                            .activityType.value =='Phone Call';else other_content">

                                <mat-form-field appearance="outline" fxFlex=100>
                                    <mat-label>Notes</mat-label>
                                    <textarea [attr.guide]="'conversation-popup-sel-notes' + '__' + sanitizeUrl(url)"
                                        required trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                        matAutosizeMaxRows=5 matInput formControlName="notes" matInput>
                                                </textarea>
                                    <mat-error *ngIf="firstFormGroup.controls.notes.errors?.required">
                                        Please fill out this field.
                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <ng-template #other_content>
                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Notes</mat-label>
                                    <textarea [attr.guide]="'conversation-popup-sel-notes' + '__' + sanitizeUrl(url)"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        required matInput formControlName="notes" matInput>
                                                </textarea>
                                    <mat-error *ngIf="firstFormGroup.controls.notes.errors?.required">
                                        Please fill out this field.
                                    </mat-error>

                                </mat-form-field></ng-template>

                        </div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <mat-form-field fxFlex appearance="outline"
                                *ngIf="firstFormGroup.controls.activityType.value!='Location'">
                                <mat-label *ngIf="firstFormGroup.value.activityType =='Phone Call'">
                                    Next Outcome</mat-label>

                                <mat-label *ngIf="firstFormGroup.value.activityType !='Phone Call'">
                                    Outcome</mat-label>
                                <mat-select formControlName="phoneCallOutcome" [disableOptionCentering]="true"
                                    #singleSelect autocomplete="off"
                                    [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0">
                                    <mat-option [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0">
                                        <ngx-mat-select-search name="Lead Status Search" ngDefaultControl
                                            [formControl]="typeYFilterControl" placeholderLabel="Lead Status Search"
                                            [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0"
                                        (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId)"
                                        *ngFor="let opt of filtereddropdownTypeList; let i=index;"
                                        [value]="opt.statusName">
                                        {{opt.statusName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>


                        </div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <div *ngIf="init&&regConfig.length>0" fxFlex="100">

                                <simple-dynamic-form (submit)="onFormSubmitted($event)"
                                    [patchValueList]="simpleFormValueList" [type]="2" fxFlex="100" [fields]="regConfig">
                                </simple-dynamic-form>


                            </div>

                        </div>

                        <div *ngIf="firstFormGroup.controls.phoneCallOutcome.value !='Completed' && firstFormGroup.controls.phoneCallOutcome.value !='completed'"
                            fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <!-- Date picker -->
                            <mat-form-field appearance="outline" fxFlex="50">
                                <mat-label>Due Date</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-duedate' + '__' + sanitizeUrl(url)"
                                    matInput [min]="firstFormGroup.value.id==0?today:'  '" [matDatepicker]="picker"
                                    formControlName="dueDate" placeholder="MM/DD/YYYY" />
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>


                            <mat-form-field appearance="outline" fxFlex="50">
                                <mat-label>Due Time</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-16' + '__' + sanitizeUrl(url)" matInput
                                    [readonly]="firstFormGroup.value.status == '1' && firstFormGroup.value.id > 0"
                                    type="time" class="custom-time-input" formControlName="dueTime">
                            </mat-form-field>
                        </div>


                        <div *ngIf="enableLocation == '1' && firstFormGroup.controls.activityType.value !='Location' && firstFormGroup.controls.phoneCallOutcome.value!='Followup'"
                            fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <div *ngIf="textmap !== 'Get Current Location'">{{ textmap }}</div>
                            <mat-form-field *ngIf="textmap === 'Get Current Location'" appearance="outline" fxFlex>
                                <mat-label>Location</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-customeraddress' + '__' + sanitizeUrl(url)"
                                    readonly formControlName="customerAddress" matInput />
                            </mat-form-field>
                        </div>
                        <p style="color:red;margin-top: -20px;margin-bottom: 10px;" *ngIf="initNotes">Please fill out
                            this field.</p>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxLayoutAlign="start stretch"
                            *ngIf="firstFormGroup.controls.activityType.value=='Location'">
                            <mat-form-field appearance="outline" fxFlex="70" fxFlex.lt-md="100">
                                <mat-label>Add Location</mat-label>
                                <textarea
                                    [attr.guide]="'conversation-popup-sel-customeraddress' + '__' + sanitizeUrl(url)"
                                    readonly trim="blur" matTextareaAutosize matAutosizeMinRows="1"
                                    matAutosizeMaxRows="5" matInput formControlName="customerAddress">
                            </textarea>
                            </mat-form-field>

                            <div fxFlex="30" fxFlex.lt-md="100" fxLayoutAlign="start center"
                                class="location-button-container">

                                <button [attr.guide]="'conversation-popup-btn-17' + '__' + sanitizeUrl(url)"
                                    [disabled]="textmap !='Get Current Location'" (click)="getUserLocation()"
                                    mat-raised-button>
                                    <mat-icon>gps_fixed</mat-icon>
                                    {{textmap}}
                                    <mat-icon *ngIf="textmap !='Get Current Location' ">
                                        <mat-spinner color="primary" diameter="20">
                                        </mat-spinner>
                                    </mat-icon>
                                </button>

                            </div>
                        </div>


                        <div *ngIf="
  firstFormGroup.controls.phoneCallOutcome.value?.toLowerCase() !== 'completed' &&
  firstFormGroup.controls.phoneCallOutcome.value?.toLowerCase() !== 'pending'
">

                            <div style="padding-top: 10px;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">



                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Reminder Before the task</mat-label>
                                    <mat-select formControlName="reminder" [disabled]="activityType=='Edit'">
                                        <mat-option *ngFor="let status of reminder" [value]="status.value">
                                            {{status.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="firstFormGroup.controls.reminder.errors?.required">
                                        Please fill out this field.
                                    </mat-error>
                                </mat-form-field>



                            </div>


                        </div>

                        <div fxLayout="row" *ngIf="firstFormGroup.value.activityType =='Phone Call'
                && firstFormGroup.value.automated== 0">

                            <div class="audio" fxLayoutAlign="center center">

                                <span fxLayoutAlign="center center">
                                    Audio File
                                </span>

                            </div>

                            <calsoft-audio-upload fxFlex="100" [finalValue]="firstFormGroup.value.schedule"
                                (sendValue)="getValue($event)">

                            </calsoft-audio-upload>
                        </div>

                    </div>
                </div>



            </div>

            <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">

                <button [attr.guide]="'conversation-popup-btn-18' + '__' + sanitizeUrl(url)" type="button"
                    mat-raised-button (click)="close()">Cancel
                </button>

                <button [attr.guide]="'conversation-popup-btn-19' + '__' + sanitizeUrl(url)" [disabled]="text !='Save'"
                    (click)="submit()" mat-raised-button>
                    {{text}}
                    <mat-icon *ngIf="text !='Save' ">
                        <mat-spinner color="primary" diameter="20">
                        </mat-spinner>
                    </mat-icon>
                </button>


            </div>
        </div>
    </mat-dialog-content>
</div>

<div id="popup" *ngIf="taskType == 4" class="newTypetaskTwo">
    <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <span>
            Activity
        </span>
        <button [attr.guide]="'conversation-popup-btn-14' + '__' + sanitizeUrl(url)" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <mat-dialog-content style="max-height: calc(100vh - 64px); margin: 0; padding: 0; overflow: auto;">
        <div class="padding-11">
            <div fxLayout="column" [formGroup]="firstFormGroup">

                <div class="Activity Details">

                    <div>
                        <div fxLayout="column">
                            <div *ngIf="(firstFormGroup.controls.activityType.value !='Phone Call') && firstFormGroup.controls.phoneCallOutcome.value?.toLowerCase() !== 'completed' &&
  firstFormGroup.controls.phoneCallOutcome.value?.toLowerCase() !== 'pending'
" fxLayout="row" class="checkbox-new">
                                <mat-checkbox [attr.guide]="'conversation-popup-chk-status' + '__' + sanitizeUrl(url)"
                                    formControlName="status">
                                    Mark as Completed
                                </mat-checkbox>
                            </div>
                            <mat-form-field *ngIf="firstFormGroup.controls.activityType.value !='Phone Call'"
                                appearance="outline" fxFlex>
                                <mat-label>Title</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-subject' + '__' + sanitizeUrl(url)"
                                    formControlName="subject" matInput />
                                <!-- <mat-error *ngIf="firstFormGroup.controls.subject.errors?.required">
                                    Please fill out this field.
                                </mat-error> -->
                            </mat-form-field>

                        </div>





                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Task Type</mat-label>
                                <mat-select formControlName="activityType" [disabled]="activityType=='Edit'">
                                    <mat-option *ngFor="let status of activityTypeList" [value]="status.value">
                                        {{status.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>



                            <mat-form-field *ngIf="type!='lead'" appearance="outline" fxFlex>
                                <mat-label>Associated Lead</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-15' + '__' + sanitizeUrl(url)"
                                    [readonly]="activityId > 0" [autocomplete]="'off'" trim="blur" matInput
                                    formControlName="owner">
                            </mat-form-field>

                        </div>



                        <div *ngIf="durarationVisible" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">


                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Duration</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-typeandtime' + '__' + sanitizeUrl(url)"
                                    numbersOnly [readonly]=" firstFormGroup.value.automated==1" [autocomplete]="'off'"
                                    trim="blur" matInput formControlName="typeAndTime" />
                            </mat-form-field>

                        </div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <div fxFlex="100" *ngIf="!durarationVisible&&firstFormGroup.controls
                            .activityType.value =='Phone Call';else other_content">

                                <mat-form-field appearance="outline" fxFlex=100>
                                    <mat-label>Notes</mat-label>
                                    <textarea [attr.guide]="'conversation-popup-sel-notes' + '__' + sanitizeUrl(url)"
                                        required trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                        matAutosizeMaxRows=5 matInput formControlName="notes" matInput>
                                                </textarea>
                                    <mat-error *ngIf="firstFormGroup.controls.notes.errors?.required">
                                        Please fill out this field.
                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <ng-template #other_content>
                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Notes</mat-label>
                                    <textarea [attr.guide]="'conversation-popup-sel-notes' + '__' + sanitizeUrl(url)"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        required matInput formControlName="notes" matInput>
                                                </textarea>
                                    <mat-error *ngIf="firstFormGroup.controls.notes.errors?.required">
                                        Please fill out this field.
                                    </mat-error>

                                </mat-form-field></ng-template>

                        </div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <mat-form-field fxFlex appearance="outline"
                                *ngIf="firstFormGroup.controls.activityType.value!='Location'">
                                <mat-label *ngIf="firstFormGroup.value.activityType =='Phone Call'">
                                    Next Outcome</mat-label>

                                <mat-label *ngIf="firstFormGroup.value.activityType !='Phone Call'">
                                    Outcome</mat-label>
                                <mat-select formControlName="phoneCallOutcome" [disableOptionCentering]="true"
                                    #singleSelect autocomplete="off"
                                    [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0">
                                    <mat-option [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0">
                                        <ngx-mat-select-search name="Lead Status Search" ngDefaultControl
                                            [formControl]="typeYFilterControl" placeholderLabel="Lead Status Search"
                                            [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option [disabled]="activityType=='Edit'&&firstFormGroup.value.automated==0"
                                        (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId)"
                                        *ngFor="let opt of filtereddropdownTypeList; let i=index;"
                                        [value]="opt.statusName">
                                        {{opt.statusName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>


                        </div>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <div *ngIf="init&&regConfig.length>0" fxFlex="100">

                                <simple-dynamic-form (submit)="onFormSubmitted($event)"
                                    [patchValueList]="simpleFormValueList" [type]="2" fxFlex="100" [fields]="regConfig">
                                </simple-dynamic-form>


                            </div>

                        </div>

                        <div *ngIf="firstFormGroup.controls.phoneCallOutcome.value !='Completed' && firstFormGroup.controls.phoneCallOutcome.value !='completed'"
                            fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                            <!-- Date picker -->
                            <mat-form-field appearance="outline" fxFlex="50">
                                <mat-label>Due Date</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-duedate' + '__' + sanitizeUrl(url)"
                                    matInput required [min]="firstFormGroup.value.id==0?today:'  '"
                                    [matDatepicker]="picker" formControlName="dueDate" placeholder="MM/DD/YYYY" />
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                <mat-error *ngIf="firstFormGroup.controls.dueDate.errors?.required">
                                    Please fill out this field.
                                </mat-error>
                            </mat-form-field>


                            <mat-form-field appearance="outline" fxFlex="50">
                                <mat-label>Due Time</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-16' + '__' + sanitizeUrl(url)" matInput
                                    required
                                    [readonly]="firstFormGroup.value.status == '1' && firstFormGroup.value.id > 0"
                                    type="time" class="custom-time-input" formControlName="dueTime">
                                <mat-error *ngIf="firstFormGroup.controls.dueTime.errors?.required">
                                    Please fill out this field.
                                </mat-error>
                            </mat-form-field>
                        </div>


                        <div *ngIf="enableLocation == '1' && firstFormGroup.controls.activityType.value !='Location' && firstFormGroup.controls.phoneCallOutcome.value!='Followup'"
                            fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                            <div *ngIf="textmap !== 'Get Current Location'">{{ textmap }}</div>
                            <mat-form-field *ngIf="textmap === 'Get Current Location'" appearance="outline" fxFlex>
                                <mat-label>Location</mat-label>
                                <input [attr.guide]="'conversation-popup-inp-customeraddress' + '__' + sanitizeUrl(url)"
                                    readonly formControlName="customerAddress" matInput />
                            </mat-form-field>
                        </div>
                        <p style="color:red;margin-top: -20px;margin-bottom: 10px;" *ngIf="initNotes">Please fill out
                            this field.</p>

                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxLayoutAlign="start stretch"
                            *ngIf="firstFormGroup.controls.activityType.value=='Location'">
                            <mat-form-field appearance="outline" fxFlex="70" fxFlex.lt-md="100">
                                <mat-label>Add Location</mat-label>
                                <textarea
                                    [attr.guide]="'conversation-popup-sel-customeraddress' + '__' + sanitizeUrl(url)"
                                    readonly trim="blur" matTextareaAutosize matAutosizeMinRows="1"
                                    matAutosizeMaxRows="5" matInput formControlName="customerAddress">
                            </textarea>
                            </mat-form-field>

                            <div fxFlex="30" fxFlex.lt-md="100" fxLayoutAlign="start center"
                                class="location-button-container">

                                <button [attr.guide]="'conversation-popup-btn-17' + '__' + sanitizeUrl(url)"
                                    [disabled]="textmap !='Get Current Location'" (click)="getUserLocation()"
                                    mat-raised-button>
                                    <mat-icon>gps_fixed</mat-icon>
                                    {{textmap}}
                                    <mat-icon *ngIf="textmap !='Get Current Location' ">
                                        <mat-spinner color="primary" diameter="20">
                                        </mat-spinner>
                                    </mat-icon>
                                </button>

                            </div>
                        </div>


                        <div *ngIf="
  firstFormGroup.controls.phoneCallOutcome.value?.toLowerCase() !== 'completed' &&
  firstFormGroup.controls.phoneCallOutcome.value?.toLowerCase() !== 'pending'
">

                            <div style="padding-top: 10px;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">



                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Reminder Before the task</mat-label>
                                    <mat-select formControlName="reminder" [disabled]="activityType=='Edit'">
                                        <mat-option *ngFor="let status of reminder" [value]="status.value">
                                            {{status.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="firstFormGroup.controls.reminder.errors?.required">
                                        Please fill out this field.
                                    </mat-error>
                                </mat-form-field>



                            </div>


                        </div>

                        <div fxLayout="row" *ngIf="firstFormGroup.value.activityType =='Phone Call'
                && firstFormGroup.value.automated== 0">

                            <div class="audio" fxLayoutAlign="center center">

                                <span fxLayoutAlign="center center">
                                    Audio File
                                </span>

                            </div>

                            <calsoft-audio-upload fxFlex="100" [finalValue]="firstFormGroup.value.schedule"
                                (sendValue)="getValue($event)">

                            </calsoft-audio-upload>
                        </div>

                    </div>
                </div>



            </div>

            <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">

                <button [attr.guide]="'conversation-popup-btn-18' + '__' + sanitizeUrl(url)" type="button"
                    mat-raised-button (click)="close()">Cancel
                </button>

                <button [attr.guide]="'conversation-popup-btn-19' + '__' + sanitizeUrl(url)" [disabled]="text !='Save'"
                    (click)="submit()" mat-raised-button>
                    {{text}}
                    <mat-icon *ngIf="text !='Save' ">
                        <mat-spinner color="primary" diameter="20">
                        </mat-spinner>
                    </mat-icon>
                </button>


            </div>
        </div>
    </mat-dialog-content>
</div>